var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.367,
    height: 31.367,
    viewBox: "0 0 31.367 31.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M23.525,0H7.842A7.766,7.766,0,0,0,0,7.842V23.525a7.766,7.766,0,0,0,7.842,7.842H23.525a7.766,7.766,0,0,0,7.842-7.842V7.842A7.766,7.766,0,0,0,23.525,0ZM28.23,23.525a4.621,4.621,0,0,1-4.705,4.705H7.842a4.621,4.621,0,0,1-4.705-4.705V7.842A4.621,4.621,0,0,1,7.842,3.137H23.525A4.621,4.621,0,0,1,28.23,7.842Z",
    fill: "#74767d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M12.842,5A7.766,7.766,0,0,0,5,12.842a7.766,7.766,0,0,0,7.842,7.842,7.766,7.766,0,0,0,7.842-7.842A7.766,7.766,0,0,0,12.842,5Zm0,12.547a4.621,4.621,0,0,1-4.705-4.705,4.621,4.621,0,0,1,4.705-4.705,4.621,4.621,0,0,1,4.705,4.705A4.621,4.621,0,0,1,12.842,17.547Z",
    transform: "translate(2.842 2.842)",
    fill: "#74767d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(22 6)",
    fill: "#74767d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.4ef8ceb104d463da3a0740569d291c91.svg";
export { ForwardRef as ReactComponent };